// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"Term_Privacy_textContainer__1Adud","headerContainer":"Term_Privacy_headerContainer__1EJHb","hLine":"Term_Privacy_hLine__2-7pd"};